module.exports = __webpack_public_path__ + "static/media/046.4100eb6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/046.jpg
// module id = 391
// module chunks = 0